import Abstract from '../../framework/Abstract';

import './B5-4-column-content.scss';

class ColumnContent extends Abstract {
	init() {}
}

export default ColumnContent;
